<template>
  <div class="pay-order-content" v-show="show" v-loading="loading">
    <rt-card :title="''">
<!--      <i @click="cancel" class="el-icon-close" />-->
      <div class="pay-order-main">
        <tabSelect class="gate-item" ref="tabSelect" :gateArrStr="leftGateTabStr" @change="tebChange" style="width: calc(100% - 20px);"></tabSelect>
        <template>
          <div class="pay-order-btn-group">
            <el-button type="primary" plain size="mini" @click="getOrder(orderData)">刷新</el-button>
            <el-button type="primary" size="mini" @click="handleShowList(orderData.plateNumber)">查找记录</el-button>
            <el-button type="primary" size="mini" @click="handleShowPlateNum(orderData.plateNumber)">修改车牌</el-button>
            <el-button
              type="text"
              class="btn-radio"
              :disabled="orderData.isPaid || orderData.leftAt !== ''"
              @click="handleReport">
              <el-image :src="require('@/assets/img/radiod02@2x.png')" alt="" style="width: 15px;" v-if="orderData.isPaid || orderData.leftAt !== ''"></el-image>
              <el-image :src="require('@/assets/img/radio02@2x.png')" alt="" style="width: 15px;" v-else></el-image>
            </el-button>
          </div>
          <div class="pay-amount-item plate">
            {{ orderData.plateNumber }}
            <b v-if="orderData.parkingLength !== ''">{{
              "(" + orderData.parkingLength + ")"
              }}</b>
            <el-tag :type="titleObj.type" v-if="orderData.id !== -1">{{titleObj.value}}</el-tag>
            <el-tag type="info" v-else>暂无记录</el-tag>
          </div>
          <ul>
            <li>
              <p style="display: flex; align-items: center;">
                <span>入场时间：</span>
                <span v-if="orderData.cameAt === ''">
                <el-date-picker
                  v-model="orderCameAtDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 140px;"
                  placeholder="日期">
                </el-date-picker>
                  -
                <el-time-picker
                  v-model="orderCameAtTime"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  :picker-options="{selectableRange:`00:00:00-${endTime}`}"
                  style="width: 140px;"
                  placeholder="时间">
                </el-time-picker>
                <el-button type="text" :disabled="orderCameAt === '' || !orderCameAt" @click="getCarSizeItem({value: orderCameAt, key: 'cameAt'})">提交</el-button>
              </span>
                <span v-else>{{ orderData.cameAt }}</span>
              </p>
              <p>
                <span>出场时间：</span><span>{{ orderData.leftWaitAt }}</span>
              </p>
            </li>
            <li class="li-flex">
              <div v-if="chargeList['费用总额']"><span>费用总额：</span><span>{{ orderData.payableAmount3 }}</span></div>
<!--              <div><span>车型：</span><span>{{ showCarSizeTable(orderData.carSize) }}</span></div>-->
              <div v-if="chargeList['优惠金额']"><span>优惠金额：</span><span>{{ orderData.couponMoney }}</span></div>
              <div v-if="chargeList['入场车道']"><span>入场车道：</span><span>{{ orderData.entranceName }}</span></div>
              <div v-if="chargeList['充电费用']"><span>充电费用：</span><span>{{ 0 }}</span></div>
              <div v-if="chargeList['分组钱包已付']"><span>分组钱包已付：</span><span>{{ orderData.companyPayMoney }}</span></div>
              <div v-if="chargeList['分组钱包余额']"><span>分组钱包余额：</span><span>{{ orderData.companyOrVehicleWallet }}</span></div>
              <div v-if="chargeList['电子已付']"><span>电子已付：</span><span>{{ orderData.moneyValuePaid }}</span></div>
              <div v-if="chargeList['出场车道']"><span>出场车道：</span><span>{{ orderData.exitName }}</span></div>
              <div v-if="chargeList['电子还需付']"><span>电子还需付：</span><span style="color: red;">{{ orderData.moneyValueToPay2 }}</span></div>
              <div v-if="chargeList['提示信息']"><span>提示信息：</span><span style="color: red;">{{ infoMsg }}</span></div>
              <div v-if="chargeList['预约抵扣费']"><span>预约抵扣费：</span><span>{{ 0 }}</span></div>
              <div v-if="chargeList['场内已付']"><span>场内已付：</span><span>{{ orderData.moneyValuePaid }}</span></div>
            </li>
            <li v-if="orderData.isBillPack === 1">
              <p><span>月卡开始时间：</span><span>{{ orderData.billPackList[0].billPackStartTime }}</span></p>
              <p><span>月卡结束时间：</span><span>{{ orderData.billPackList[0].billPackEndTime }}</span></p>
              <div class="billPackList-btn">
                <div>
                  <span>剩余天数：</span><span>{{ orderData.billPackDay }}</span>
                </div>
                <el-popover
                  placement="right"
                  width="260"
                  trigger="click">
                  <div v-for="(v, i) in orderData.billPackList" :key="i" style="margin-bottom: 10px;">
                    <p><span>月卡开始时间：</span><span>{{ v.billPackStartTime }}</span></p>
                    <p><span>月卡结束时间：</span><span>{{ v.billPackEndTime }}</span></p>
                  </div>
                  <el-button slot="reference" type="text">月卡详情</el-button>
                </el-popover>
              </div>
            </li>
            <li v-if="orderData.isBillPack !== 1 && Boolean(setConfig.EditCarType)">
              <p style="display: block; text-align: left;">
                车型修改：<car-size-select ref="carSizeSelect" v-model="orderData.carSize" @change="getCarSizeItem"></car-size-select>
              </p>
            </li>
          </ul>
          <div class="pay-amount-item">
            <span>
              <div style="color: red;">¥:{{orderData.moneyValueToPay3}}</div>
              <div style="font-size: 14px; font-weight: normal; line-height: 1; text-align: center;">现金还需</div>
            </span>
          </div>
          <el-button type="" class="btn-code" @click="handleShowCode" :disabled="orderData.leftAt !== '' || orderData.isPaid" v-if="Boolean(setConfig.ShowCodeGun)">
            <el-image :src="require('@/assets/img/codeIcond.png')" alt="" style="width: 20px;" v-if="orderData.leftAt !== '' || orderData.isPaid"></el-image>
            <el-image :src="require('@/assets/img/codeIcon.png')" alt="" style="width: 20px;" v-else></el-image>
            扫码支付
          </el-button>
          <div class="pay-btn-item" v-if="chargeButton['确认收费']">
            <el-button
              @click="confirmPay"
              class="confirm-btn"
              :disabled="orderData.leftAt !== ''|| orderData.cameAt === '' || orderData.isPaid || orderData.moneyValueToPay3 === 0 || displayConfirmPay"
              type="primary"
            >确认收费</el-button
            >
          </div>
          <div class="pay-btn-item" v-if="chargeButton['异常开闸']">
            <el-button
              @click="confirmOpenGate"
              class="btn-mini"
              style="padding: 12px 50px;"
              type="warning"
            >异常开闸<b v-if="!Boolean(setConfig.ShowCodeGun)">(Enter键)</b></el-button>
          </div>
          <div class="pay-btn-item" v-if="chargeButton['免费开闸']">
            <el-button
              @click="freeOpen"
              class="confirm-btn"
              :disabled="orderData.leftAt !== '' || orderData.isPaid"
              type="danger"
            >免费开闸</el-button>
          </div>
          <div class="pay-btn-item" v-if="chargeButton['直接开闸']">
            <el-button
              @click="justOpen"
              class="confirm-btn"
              style="width: 100%; margin-top: 10px;"
              :disabled="orderData.id === -1 || !(orderData.cameAt !== '' && (orderData.moneyValueToPay2 === 0 || orderData.moneyValueToPay3 === 0))"
              type="success"
            >直接开闸</el-button>
          </div>
          <ul v-if="orderData.id !== -1">
            <li class="li-flex li-img">
              <el-image
                :src="orderData.passInFullImage"
                fit="contain"
                :preview-src-list="[...orderData.passInFullImage]"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">暂无图片</div>
              </el-image>
              <el-image
                :src="orderData.passOutFullImage"
                fit="contain"
                :preview-src-list="[...orderData.passOutFullImage]"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">暂无图片</div>
              </el-image>
            </li>
          </ul>
        </template>
      </div>
    </rt-card>
    <el-dialog
      custom-class="real-dialog"
      :visible.sync="showPlateNum"
      width="30%"
      append-to-body
      center>
      <el-input class="dialog-plateNum" v-model="showDialogPlateNum" placeholder="请输入车牌号"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCarSizeItem({value: showDialogPlateNum, key: 'plateNumber'})">确 定</el-button>
        <el-button type="warning" @click="showPlateNum = false">取 消</el-button>
      </span>
    </el-dialog>
    <dialogDeductionVoucher
      title="折扣"
      :showdialog.sync="showDeductionVoucher"
    />
    <!-- <dialogGetInvoice title="开具发票" :showdialog.sync="showGetInvoice" /> -->
    <dialogHandleOutIn
      @getReason="confirmOpenGate"
      title="免费开闸"
      ref="mychild"
      :showdialog.sync="showHandleOutIn"
    />
    <dialog-pay-order-list
      ref="payOrderList"
      v-if="centerDialogVisible"
      :showdialog.sync="centerDialogVisible"
    ></dialog-pay-order-list>
    <dialog-auth-code
      v-if="showAuthCode"
      :showdialog.sync="showAuthCode"
      :form="orderData"
    ></dialog-auth-code>
    <dialog-handle-table-out
      v-if="showHandleTableOut"
      :showdialog.sync="showHandleTableOut"
      @getOutGateId="confirmOutGate"
    ></dialog-handle-table-out>
  </div>
</template>

<script>
import rtCard from "@/serviceComponents/rtCard.vue";
import dialogDeductionVoucher from "@/serviceComponents/dialogDeductionVoucher";
// import dialogGetInvoice from "./dialogGetInvoice";
import dialogHandleOutIn from "@/serviceComponents/dialogHandleOutIn";
import { orderPubSub, parkOutPubSub, settingPubSub, eventPubSub } from "@/service/pubsub/index";
import { openGate, confirmOrderMoney } from "@/api/module/park";
import ParkLotMix from "@/minxs/parkLotId";
import showdialog from "@/minxs/showdialog";
import { getOrder, updateOrder, report } from "@/api/module/tenant";
// import gateSelect from "@/serviceComponents/gateSelect";
import tabSelect from "@/serviceComponents/tabSelect";
import { voicePrompt } from "@/utils/voicePrompt";
import dialogPayOrderList from "@/serviceComponents/dialogPayOrderList";
import dialogAuthCode from "@/serviceComponents/dialogAuthCode";
import carSizeSelect from "@/serviceComponents/carSizeSelect";
import dialogHandleTableOut from "@/serviceComponents/dialogHandleTableOut";
import { getChargingPopUp, getOutGateId } from "@/utils/service";

export default {
  components: {
    rtCard,
    dialogDeductionVoucher,
    // dialogGetInvoice,
    dialogHandleOutIn,
    // gateSelect,
    tabSelect,
    dialogPayOrderList,
    dialogAuthCode,
    carSizeSelect,
    dialogHandleTableOut,
  },
  mixins: [ParkLotMix, showdialog],
  data() {
    return {
      payForm: {},
      orderMoney: "6",
      realMoney: "6",
      showGetInvoice: false,
      showHandleOutIn: false,
      showDeductionVoucher: false,
      OutGateId: "",
      orderData: {
        id: -1,
        orderNo: "",
        parkingName: "",
        parkLotId: -1,
        parkSpotNumber: "",
        parkSpotId: 0,
        plateNumber: "",
        plateNumId: 0,
        plateColor: 1,
        parkStatus: "",
        status: 0,
        orderStatus: "正常",
        leftAt: "--",
        cameAt: "--",
        payableAmount: "0.00",
        moneyValueToPay: 0,
        moneyValuePaid: 0,
        payStatus: "--",
        paidAt: null,
        cashChannelId: 0,
        remark: "",
        parkingLength: "--",
        foreignFrom: "",
        parkPassingInId: -1,
        parkPassingOutId: -1,
        entranceName: "--",
        exitName: "--",
        isBillPack: 2,
        carSize: 0,
        carType: "--",
        couponMoney: 0,
        createdAt: "--",
        passType: 1,
      },
      show: false,
      loading: false,
      titleObj: {},
      showPaySuccess: false,
      showPayError: false,
      infoMsg: '',
      setConfig: {
        ChargeList: [],
        ChargeButton: [],
      },
      orderCameAtDate: '',
      orderCameAtTime: '',
      endTime: '',
      centerDialogVisible: false,
      showAuthCode: false,
      AuthCode: undefined,
      // leftGateTabStr: undefined,
      showPlateNum: false,
      showDialogPlateNum: undefined,
      displayConfirmPay: false,
      showHandleTableOut: false,
    };
  },
  watch: {
    GateId: function (newV) {
      this.OutGateId = newV;
      // this.$refs.tabSelect.gateId = String(newV);
    },
    isShowOrderDetail: function (newV) {
      if (!newV) {
        this.resetOrder();
        this.show = false;
        this.titleObj = {};
      }
    },
    wsOrderArrStr: {
      handler(val){
        let arr = JSON.parse(val);
        // console.log(arr);
        this.leftGateTab.forEach(v => {
          let arr02 = arr.filter(vv => {return parseInt(vv.park_lot_gate_id) === v.Id});
          if (arr02.length === 0) {
            v.hidden = true
          } else {
            v.orderId = parseInt(arr02[0].order_id);
            v.hidden = arr02[0].isPaid
          }
        });
        this.$store.dispatch("SetLeftGateTabStr", JSON.stringify(this.leftGateTab));
        // console.log('leftArr', this.leftGateTab);
        this.$forceUpdate();
      },
      deep:true
    },
  },
  computed: {
    direction: function () {
      return this.$route.params.Direction ? this.$route.params.Direction : "";
    },
    isShowOrderDetail: function () {
      return this.$store.state.order.showOrderDetail;
    },
    GateId: function () {
      // let arr = this.$store.state.order.gateIds
      //   ? this.$store.state.order.gateIds
      //   : [];
      // let leftArr = arr.filter((item) => {
      //   return Number(item.Direction) === 2;
      // });
      // let id = leftArr[0] ? leftArr[0].Id : undefined;
      return this.$store.state.order.pubOutGateId;
    },
    wsOrderArr: function () {
      return this.$store.state.order.wsOrderArr;
    },
    wsOrderArrStr: function() {
      return this.$store.state.order.wsOrderArrStr
    },
    leftGateTab: function() {
      let arr = this.$store.state.order.gateIds
        ? this.$store.state.order.gateIds
        : [];
      let leftArr = arr.filter((item) => {
        return Number(item.Direction) === 2;
      });
      return leftArr
    },
    chargeList: function () {
      let obj = {};
      this.setConfig.ChargeList.forEach(v => {
        obj[v] = true
      });
      return obj
    },
    chargeButton: function() {
      let obj = {};
      this.setConfig.ChargeButton.forEach(v => {
        obj[v] = true
      });
      return obj
    },
    orderCameAt: function () {
      if(this.orderCameAtDate === '' || !this.orderCameAtDate || this.orderCameAtTime === '' || !this.orderCameAtTime) {
        return ''
      } else {
        return this.orderCameAtDate + ' ' + this.orderCameAtTime
      }
    },
    leftGateTabStr: function () {
      return this.$store.state.order.leftGateTabStr
    },
  },
  mounted() {
    const that = this;
    orderPubSub.unsubscribe();
    orderPubSub.subscribe(this.getOrder);
    if (this.GateId) {
      this.OutGateId = this.GateId;
      // this.$refs.item.server(true);
    }
    this.displayConfirmPay = false;
    document.onkeyup = function (e) {
      // console.log('showOrderDetail',that.isShowOrderDetail)
      // console.log('showHandleOutIn',that.showHandleOutIn)
      if (e.keyCode == 32 && that.isShowOrderDetail && !that.showHandleOutIn && !that.showAuthCode && that.chargeButton['确认收费']) {
        // window.event.preventDefault(); //关闭浏览器快捷键
        // that.confirmPay();
      } else if (e.keyCode == 13 && that.isShowOrderDetail && !that.showHandleOutIn && !that.showAuthCode && !that.setConfig.ShowCodeGun && that.chargeButton['异常开闸']) {
        // 异常开闸
        window.event.preventDefault();
        that.confirmOpenGate();
      } else if (
        e.keyCode == 32 &&
        that.isShowOrderDetail &&
        that.showHandleOutIn
      ) {
        window.event.preventDefault(); //关闭浏览器快捷键
        that.clickParent();
      }
    };
    settingPubSub.subscribe(this.getSetting);
    if (this.GateId=== '') {
      this.$store.dispatch("SetPayOrderGateId", !getOutGateId() ? this.leftGateTab[0].Id : parseInt(getOutGateId()));
    }
  },
  methods: {
    // 获取订单
    getOrder(data) {
      // console.log(data);
      this.show = true;
      this.loading = true;
      this.$refs.tabSelect.gateId = '';
      try {
        // data.otherMsg = {"parkingLength":"2小时29分51秒","moneyValueToPay":36.59,"address":"杭州市富阳区富春街道北环路419号","plateNumber":"粤BF12345","name":"杭州市富阳区第一人民医院停车场","payStatus":false,"paidAt":"","leftAt":"","cameAt":"2021-01-13 14:19:46","images":["http://ncloud.test.zhuyitech.com:8888/upload/parking_passings_photo/202101/205b75b259a2c6ae671649407e2ba811_粤BF12345.png","http://ncloud.test.zhuyitech.com:8888/upload/parking_passings_photo/202101/d691c0691eafa5d2b652cb4148a88e3e_粤BF12345.png","http://ncloud.test.zhuyitech.com:8888/upload/parking_passings_photo/202101/49bde13ec7b090cc1173f3754ed85698_粤BF12345.png","http://ncloud.test.zhuyitech.com:8888/upload/parking_passings_photo/202101/a622a80d5d879fa131a6659c8fd50e2c_粤BF12345.png"],"parkSpotNumber":"","plateColor":4,"carType":0,"parkStatus":"在停中","status":0,"orderStatus":"正常","ForeignFrom":"","cashChannelId":0,"remark":"预存","id":84934189,"orderId":"302021011316493713972","moneyValuePaid":"0.00","payableAmount":"36.59","entranceName":"西门入口1","exitName":"公卫出口1","outGateId":215,"isBillPack":2,"carSize":2,"couponMoney":0,"carTypeStr":"临停车","billPackStartTime":null,"billPackEndTime":null,"billPackDay":0,"companyPayMoney":0,"errorMsg":""}
        if (data && data.InfoMsg) {
          this.infoMsg = data.InfoMsg;
        }
        if (data && data.otherMsg) {
          this.OutGateId = Number(data.park_lot_gate_id);
          this.$refs.tabSelect.gateId = data.park_lot_gate_id;
          // this.orderData = JSON.parse(data.otherMsg);
          // console.log('参数',this.orderData)
          let obj = JSON.parse(data.otherMsg);
          obj.isPaid = data.isPaid;
          this.fillOrderCard(obj);
          this.loading = false;
        } else {
          // console.log(data);
          const id = data.id ? data.id : data.Id;
          if (data.park_lot_gate_id) {
            this.OutGateId = data.park_lot_gate_id;
            this.$refs.tabSelect.gateId = data.park_lot_gate_id;
          }
          if (id === -1) {
            this.show = true;
            this.loading = false;
            this.OutGateId = this.$store.state.order.payOrderGateId ? this.$store.state.order.payOrderGateId : this.GateId;
            this.$refs.tabSelect.gateId = String(this.OutGateId);
            this.$store.dispatch("SetPayOrderGateId", this.OutGateId);
            this.resetOrder();
          } else {
            getOrder({ Id: Number(id) }).then((res) => {
              this.loading = false;
              if (res.state === "success") {
                res.data.isPaid = data.isPaid;
                this.fillOrderCard(res.data)
              } else {
                this.orderData = {}
              }
            });
          }
        }
        this.setConfig = JSON.parse(getChargingPopUp());
      } catch (error) {
        console.log("err", error);
      }
    },
    // 确认收费
    async confirmPay() {
      this.displayConfirmPay = true;
      if (!this.OutGateId) {
        return this.$message({
          message: "请选择道闸",
          type: "error",
        });
      }
      let res = await confirmOrderMoney({
        Id: this.orderData.id,
        OutGateId: Number(this.OutGateId),
        MoneyValuePaid: this.orderData.moneyValueToPay3 * 1,
        PlateNumber: this.orderData.plateNumber,
        Source: 2,
      });
      if (res.state === "success") {
        // await this.confirmOpenGate();
        this.$message.success("操作成功");
        this.updateOrderArr().then(res =>{
          setTimeout(() => {
            parkOutPubSub.publish();
          }, 10000);
          voicePrompt("一路平安");
          if (res.length > 0) {
            this.getOrder(res[0]);
          }
        })
        this.displayConfirmPay = false;
      } else {
        this.$message({ message: res.message, type: "error" });
        this.displayConfirmPay = false;
      }
    },
    updateOrderArr() {
      return new Promise((resolve) => {
        this.wsOrderArr.forEach(v => {
          if (this.orderData.id === parseInt(v.order_id)) {
            v.isPaid = true
          }
        });
        this.$store.dispatch("SetWsOrderArr", this.wsOrderArr);
        let sameGateArr = this.wsOrderArr.filter(v => {
          return parseInt(v.park_lot_gate_id) === this.OutGateId && !v.isPaid
        });
        resolve (sameGateArr)
      })
    },
    // 确认开闸
    async confirmOpenGate(str) {
      openGate({
        id: this.orderData.id,
        reason: str,
        ParkLotId: this.$store.state.order.parkLotId,
        outGateId: Number(this.OutGateId),
        Source: 2,
        AbnormalType: typeof(str) === 'object' ? 2 : 11,
      }).then((res) => {
        if (res.state === "success") {
          this.updateOrderArr().then(res =>{
            if (res.length > 0) {
              this.getOrder(res[0]);
            }
            voicePrompt("一路平安");
          });
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },
    // 免费开闸
    freeOpen() {
      if (this.orderData.plateNumber.length === 0) {
        return this.$message.error("请先选择出口车道");
      }
      this.showHandleOutIn = true;
    },
    clickParent() {
      this.$refs.mychild.handleClick();
    },
    cancel() {
      this.$store.dispatch("SetWsOrderArr", []);
      this.$store.dispatch("GetShowOrderDetail", false);
    },
    openNotify() {
      this.$notify({
        title: '扣款成功',
        dangerouslyUseHTMLString: true,
        message: '<div>支付流水号：288779956240095496</div><div>已付款：3元</div>',
        type: 'success',
        duration: 0
      });
    },
    tebChange(data) {
      console.log(data);
      this.OutGateId = data.Id;
      // this.$refs.tabSelect.gateId = String(data.Id);
      this.$store.dispatch("SetPayOrderGateId", data.Id);
      if (data.orderId){
        this.getOrder({id: data.orderId, park_lot_gate_id: String(data.Id)})
      } else {
        this.resetOrder()
      }
    },
    fillOrderCard(data) {
      // console.log(data)
      this.orderData = data;
      // this.orderData.cameAt = '';
      if (this.orderData.cameAt === '') {
        let date = new Date();
        this.orderCameAtDate = this.formatDate(date);
        this.endTime = this.formatTime(date);
        // this.endTimeH = this.formatTime(date, 'h');
        // this.endTimeM = this.formatTime(date, 'm');
        // this.endTimeS = this.formatTime(date, 's');
        this.orderCameAtTime = this.formatTime(new Date(date.setTime(date.getTime()-20*60*1000)));
        // this.orderCameAtH = this.formatTime(new Date(date.setTime(date.getTime()-20*60*1000)), 'h');
        // this.orderCameAtM = this.formatTime(new Date(date.setTime(date.getTime()-20*60*1000)), 'm');
        // this.orderCameAtS = this.formatTime(new Date(date.setTime(date.getTime()-20*60*1000)), 's');
      }
      this.infoMsg = data.infoMsg;
      // console.log('fillOrderCard', this.orderData.id)
      this.show = true;
      this.$nextTick(() => {
        let typeIndex = Math.ceil(Math.random()*5);
        this.titleObj = {value: this.orderData.carTypeStr, type: this.titleType[typeIndex-1]};
        // console.log('fillOrderCard outGateId', this.orderData.outGateId, this.OutGateId)
        if(this.$refs.carSizeSelect)this.$refs.carSizeSelect.server(true);
        // if (this.orderData.outGateId > 0) {
        //   this.OutGateId = this.orderData.outGateId;
        //   this.$refs.tabSelect.gateId = String(this.orderData.outGateId);
        // } else {
        //   this.$refs.tabSelect.gateId = String(this.OutGateId);
        // }
        if (this.orderData.payableAmount * 1 > 0) {
          voicePrompt(
            `${this.orderData.plateNumber}出场，请扫码缴费${this.orderData.payableAmount}元`
          );
        } else {
          voicePrompt("一路平安");
        }
        if(this.orderData.errorMsg !== ''){
          this.$notify({
            title: '扣款失败',
            dangerouslyUseHTMLString: true,
            message:`<div>${this.orderData.errorMsg}</div>`,
            type: 'error',
          });
        }
      })
    },
    async getCarSizeItem(obj) {
      // console.log('getCarSizeItem', obj, this.orderData);
      let param = {
        id: this.orderData.id,
        payableAmount: Number(this.orderData.payableAmount),
        moneyValuePaid: Number(this.orderData.moneyValuePaid),
        status: this.orderData.status,
        plateColor: this.orderData.plateColor,
        plateNumber: this.orderData.plateNumber,
        carSize: this.orderData.carSize,
        Source: 2,
        LoginPlatform: 'gate',
      };
      param[obj.key] = obj.value;
      // console.log(param);
      let res = await updateOrder(param);
      if (res.state === "success") {
        if(obj.key === 'plateNumber') this.showPlateNum = false;
        if(obj.key === 'cameAt') this.orderCameAt = '';
        this.getOrder({id: this.orderData.id});
        eventPubSub.publish("");
      } else {
        this.$message.error(res.message);
      }
    },
    justOpen() {
      openGate({
        outGateId: Number(this.OutGateId),
        AbnormalType: 10,
        Source: 2,
      }).then((res) => {
        if (res.state === "success") {
          // this.updateOrderArr().then(res =>{
          //   if (res.length > 0) {
          //     this.getOrder(res[0]);
          //   }
          // });
          voicePrompt("一路平安");
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },
    handleShowList() {
      if (!this.OutGateId || this.OutGateId === 0 || this.OutGateId === '') {
        this.showHandleTableOut = true;
      } else {
        this.clickSimilarList();
      }
    },
    clickSimilarList() {
      this.centerDialogVisible = true;
      this.$store.dispatch("SetShowPayOrderList", true);
      this.$nextTick(() => {
        this.$refs.payOrderList.centerDialogPlateNum = this.orderData.plateNumber;
        this.$refs.payOrderList.ParkingDiffPlateCharNum = 0;
        this.$refs.payOrderList.OutGateId = this.OutGateId;
        this.$refs.payOrderList.queryList();
      })
    },
    handleShowCode() {
      this.showAuthCode = true;
      this.$store.dispatch("SetShowAuthCode", true);
    },
    resetOrder() {
      this.orderData = {
        id: -1,
        plateNumber: undefined,
        parkingLength: '--',
        cameAt: '--',
        leftAt: '--',
        payableAmount3: '--',
        carSize: '--',
        companyPayMoney: '--',
        moneyValuePaid: '--',
        moneyValueToPay2: '--',
        moneyValueToPay3: '--',
      };
      this.infoMsg = '--';
    },
    getSetting(obj) {
      this.setConfig = obj;
    },
    handleReport() {
      report({Id: this.orderData.id});
    },
    handleShowPlateNum(plateNumber) {
      this.showDialogPlateNum = plateNumber;
      this.showPlateNum = true;
    },
    confirmOutGate(str) {
      this.OutGateId = str;
      this.clickSimilarList();
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-order-content {
  position: relative;
  margin-bottom: 10px;
  & .el-icon-close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 20px;
    cursor: pointer;
    z-index: 6;
  }
}
.pay-order-main {
  text-align: center;
  margin: 0 10px;
  // min-height: 600px;
  margin-bottom: 60px;
  & .foreign-item {
    margin-top: 10px;
    text-align: center;
    padding: 10px;
    position: relative;
    & span {
      font-size: 22px;
      margin: 0 5px;
    }
  }
  & .pay-amount-item {
    margin-bottom: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 69px;
    color: #333333;
    opacity: 1;
    & span {
      font-size: 62px;
    }
    & .el-tag{
      font-size: 14px;
    }
    & b {
      padding: 0;
      margin: 0;
      font-size: 18px;
      color: #54ec91;
    }
    & .el-button--text{
      font-size: 16px;
    }
  }
  & .plate {
    font-size: 32px;
    line-height: 22px;
    font-weight: normal;
    text-align: center;
    >b{
      display: block;
      margin: 10px 0;
    }
    em{
      display: block;
      line-height: 1;
      font-size: 14px;
    }
    .el-button--text{
      padding: 0;
      font-size: 14px;
    }
  }
  & .actual-amount-item {
    margin-bottom: 30px;
    & label {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #333333;
      opacity: 1;
    }
  }
  & .discount-item {
    & p {
      margin-bottom: 10px;
      label {
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 14px;
        color: #0178ec;
        opacity: 1;
        margin-right: 10px;
        text-align: left;
      }
      & span {
        cursor: pointer;
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 24px;
        width: 120px;
        display: inline-block;
        text-align: left;
        color: #cccccc;
        opacity: 1;
      }
    }
  }
  & .pay-btn-item {
    & > p {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;
      .btn-mini {
        padding: 10px 15px;
        font-size: 14px;
      }
      & label {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 16px;
        color: #fdbc4a;
        opacity: 1;
        cursor: pointer;
      }
      & label + label {
        color: black;
      }
      & label:first-child.disabled {
        pointer-events: none;
      }
    }
  }
  & ul {
    list-style: none;
    margin-top: 15px;
    & li {
      margin-bottom: 6px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 2;
      color: #333333;
      opacity: 1;
      & p {
        display: flex;
        /*justify-content: space-between;*/
      }
    }
    .li-flex{
      display: flex;
      flex-wrap: wrap;
      div{
        width: 33%;
        text-align: left;
      }
    }
    .li-img{
      justify-content: space-between;
      .el-image{
        flex: .45;
        .image-slot{
          width: 100%;
          height: 180px;
          line-height: 180px;
          color: #fff;
          text-align: center;
          background: #d8d8d8;
        }
      }
    }
  }
  .imgBox {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // border: 1px solid #dddddd;
    &.imgEnter {
      top: 38px;
    }
    &.imgLeave {
      bottom: 30px;
    }
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
}
@media screen and (max-height: 800px){
  .pay-order-main {
    & .pay-amount-item {
      margin-bottom: 0;
      line-height: 45px;
      & span {
        font-size: 36px;
      }
      & b {
        font-size: 14px;
      }
    }
    & .plate {
      font-size: 16px;
      line-height: 16px;
    }
    & .actual-amount-item {
      margin-bottom: 15px;
      & label {
        line-height: 16px;
      }
    }
    & .discount-item {
      & p {
        margin-bottom: 10px;
        label {
          font-size: 10px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 14px;
          color: #0178ec;
          opacity: 1;
          margin-right: 10px;
          text-align: left;
        }
      }
    }
    & .pay-btn-item {
      & > p {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        .btn-mini {
          padding: 10px 15px;
          font-size: 14px;
        }
        & label {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 16px;
          color: #fdbc4a;
          opacity: 1;
          cursor: pointer;
        }
        & label + label {
          color: black;
        }
        & label:first-child.disabled {
          pointer-events: none;
        }
      }
    }
  }
}
.pay-order-main{
  ul {
    .li-flex{
      div{
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
  .gate-item {
    position: absolute;
    top: 0;
    left: 10px;
    .el-tabs__item{
      height: 35px;
      font-size: 16px;
    }
    .el-tabs__nav-wrap::after{
      background-color: transparent;
    }
    .el-badge__content.is-fixed{
      top: 8px;
    }
  }
  .btn-code{
    position: absolute;
    top: 390px;
    right: 20px;
    padding: 7px 14px;
    border: none;
    color: #0178EC;
    font-size: 18px;
    span{
      display: flex;
      align-items: center;
      .el-image{
        margin-right: 5px;
      }
    }
  }
  .plateOrderList{
    border: 1px solid #999;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px;
    height: 370px;
    overflow-y: auto;
    .item{
      width: 49%;
      height: 250px;
      margin-bottom: 10px;
      border: 2px solid transparent;
    }
    .item.active{
      border-color: #0F4BA1;
    }
  }
  .pay-btn-item{
    .el-button{
      font-size: 16px;
      width: 100%;
      margin-top: 10px;
    }
  }
  .btn-radio{
    padding: 0;
    & span{
      display: flex;
      align-items: center;
      font-size: 14px;
      .el-image{
        margin-left: 5px;
      }
    }
  }
  .el-image-viewer__wrapper{
    i.el-icon-close,
    i.el-icon-circle-close{
      color: #fff;
    }
  }
  .cameAt-input{
    width: 50px;
    .el-input__inner{
      padding: 0 0 0 5px;
    }
    .el-input__suffix{
      right: 0;
    }
  }
  .dialog-plateNum{
    font-size: 24px;
    .el-input__inner{
      height: 62px;
      line-height: 62px;
    }
  }
  .refreshOrder{
    position: absolute;
    top: 12px;
    right: 0;
  }
  .billPackList-btn{
    display: flex;
    .el-button{
      margin-left: 10px;
    }
  }
  .pay-order-btn-group{
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>
